import { createSelector } from '@reduxjs/toolkit';
import { fetchStatuses } from '../../../../constants/fetchStatuses';
import { ReducerState } from '../../../store.types';

export const companyGroupSelector = ({ companyGroup }: ReducerState) => companyGroup;

export const companyGroupsLoadingSelector = createSelector(
  companyGroupSelector,
  ({ fetchCompanyGroupsStatus }) => fetchCompanyGroupsStatus === fetchStatuses.pending,
);

export const companyGroupLoadingSelector = createSelector(
  companyGroupSelector,
  ({ fetchCompanyGroupStatus }) => fetchCompanyGroupStatus === fetchStatuses.pending,
);

export const companyGroupCreateLoadingSelector = createSelector(
  companyGroupSelector,
  ({ createCompanyGroupStatus }) => createCompanyGroupStatus === fetchStatuses.pending,
);

export const companyGroupUpdateLoadingSelector = createSelector(
  companyGroupSelector,
  ({ updateCompanyGroupStatus }) => updateCompanyGroupStatus === fetchStatuses.pending,
);
export const companyGroupUploadCsvLoadingSelector = createSelector(
  companyGroupSelector,
  ({ uploadCompanyGroupsCsvStatus }) => uploadCompanyGroupsCsvStatus === fetchStatuses.pending,
);

export const companyGroupDeleteLoadingSelector = createSelector(
  companyGroupSelector,
  ({ deleteCompanyGroupStatus }) => deleteCompanyGroupStatus === fetchStatuses.pending,
);

export const portfoliosLoadingSelector = createSelector(
  companyGroupSelector,
  ({ fetchPortfoliosStatus }) => fetchPortfoliosStatus === fetchStatuses.pending,
);
